import { ReactNode } from 'react';
import { AuthBody, AuthHeader, AuthPage, LinkWrapper } from './styles';
import { BlankLayout } from '@/bundle/Layouts/BlankLayout';
import LogoIcon from '@/images/Logo.svg?react';
import { ExternalLink } from '@/components/ExternalLink/ExternalLink';
import { envConfig } from '@/config/envConfig';

export type AuthLayoutPositionType = 'center' | 'top';

type AuthLayoutType = {
  banner?: ReactNode;
  isLoading?: boolean;
  children?: ReactNode;
  position?: AuthLayoutPositionType;
};

export const AuthLayout = ({ isLoading, banner, children, position = 'center' }: AuthLayoutType) => {
  return (
    <BlankLayout isLoading={isLoading}>
      <AuthPage>
        <AuthHeader>
          <LinkWrapper>
            <ExternalLink href={envConfig.LANDING_URL}>
              <LogoIcon />
            </ExternalLink>
          </LinkWrapper>
        </AuthHeader>
        {banner}
        <AuthBody position={position}>{children}</AuthBody>
      </AuthPage>
    </BlankLayout>
  );
};
